import { INotificationNc } from '../../../../../graphql/app-level-modals/models/get-modals-data.model';
import { NotificationType } from '../../../../../models/notification.models';

export const getControlVisitPointsNotifications = (
  notifications?: INotificationNc[],
): INotificationNc[] => (notifications || [])
  .filter(({ type }) => type === NotificationType.CONTROL_VISIT_POINTS
    || type === NotificationType.CONTROL_VISIT_POINTS_WITH_UPGRADE);
